import React from 'react';
import ContainerHeader from 'components/ContainerHeader';
import Button from '@mui/material/Button';
import axios from 'constants/axios';
import { required, minLength6, confirmPasswordMatch } from 'constants/validations';
import renderTextField from 'components/textBox';
import { Field, Form } from 'react-final-form'
import { NotificationManager } from 'react-notifications';
import SellerContainer from "components/sellerContainer"

const ChangePassword = (props) => {
  const onSubmit = async (values) => {
    let data = {
      password: values.newPassword,
      confirmPassword: values.confirmPassword,
    }
    await axios.post('/users/changePassword', data, {
      headers: {
        'Content-Type': 'application/json',
        'token': localStorage.getItem('token')
      }
    }).then(result => {
      if (result.data.error) {
        NotificationManager.error(result.data.title);
      } else {
        NotificationManager.success(result.data.title);
      }
    }).catch(error => {
      NotificationManager.error('Something went wrong, Please try again')
    });
  }

  const composeValidators = (...validators) => (value, allValues) =>
    validators.reduce((error, validator) => error || validator(value, allValues), undefined)

  return (
    <SellerContainer>
      <div className="col-xl-12 col-lg-12">
        <ContainerHeader title="Change Password" />
        <div className="jr-card">
          <Form
            onSubmit={onSubmit}
            render={({ handleSubmit }) =>
              <form onSubmit={handleSubmit} autoComplete="off">
                <Field id="newPassword" name="newPassword" type="password"
                  component={renderTextField} label="New Password"
                  validate={composeValidators(required, minLength6)}
                />
                <Field name="confirmPassword" type="password"
                  component={renderTextField} label="Confirm Password"
                  validate={confirmPasswordMatch}
                />
                <div className="mb-2">
                  <div className={'customButton'}>
                    <Button style={{ backgroundColor: '#072791' }} variant="contained" color="primary" type="submit">Save</Button>
                  </div>
                </div>
              </form>
            }
          />
        </div >
      </div >
    </SellerContainer>
  );
}

export default ChangePassword

